import { createSelector } from '@reduxjs/toolkit';

import { selectUserRegion } from '../user-api';
import { categoriesApi } from './categories-api.slice';

// For user's region value, fetch the corresponding facet value for the default
export const selectDefaultRegionFacet = createSelector(
  [selectUserRegion, categoriesApi.endpoints.fetchEpisodeFacets.select()],
  (userRegion, { data: facets }) => {
    const regionFacet = facets?.entities['audience_region'];
    const matchingFacetValue = regionFacet?.values.find(
      option =>
        (option.slug === 'CA' && userRegion === 'CAN') ||
        (option.slug === 'US' && userRegion === 'USA') ||
        (option.slug === 'GB' && userRegion === 'GBR'),
    );

    return matchingFacetValue?.slug ?? 'US';
  },
);
